import React from "react";
import { Loader2 } from "lucide-react";
import { useLocation } from "react-router-dom";
import isBot from "../../utils/isBot";
import { useTranslation } from "react-i18next";
// import BidCoinLogo from "../../assets/currentLogo.png";
/**
 *
 */
export const LoadingScreen = () => {
    const { t } = useTranslation();
    return (
        <div className="fixed inset-0 bg-gray-900 flex flex-col items-center justify-center z-50">
            <div className="text-blue-500 animate-spin mb-4">
                <Loader2 size={48} />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">{t("loadingScreen.title")}</h2>
            <p className="text-gray-400 text-center max-w-md px-4">
                {t("loadingScreen.description")}
            </p>
            <div className="mt-8 w-64 bg-gray-700 rounded-full h-2">
                <div
                    className="bg-blue-500 h-2 rounded-full animate-pulse"
                    style={{ width: "75%" }}
                ></div>
            </div>
            <div className="mt-4 flex space-x-2">
                {[1, 2, 3].map((i) => (
                    <div
                        key={i}
                        className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"
                        style={{ animationDelay: `${i * 0.2}s` }}
                    ></div>
                ))}
            </div>
        </div>
    );
};

/**
 *
 */
export const BlockchainOverlay = ({ loading }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const currentPath = location.pathname;

    const loadingPhrases = {
        //! Set phrases for each route in backend, and load once on app init func with contracts, save to localStorage to use and make null_SAFE incase localStorage is cleared
        "/": [t("loadingPhrases.home.0"), t("loadingPhrases.home.1")],
        "/auction-details/*": [
            t("loadingPhrases.auctionDetails.0"),
            t("loadingPhrases.auctionDetails.1"),
        ],
        "/auctions": [t("loadingPhrases.auctions.0"), t("loadingPhrases.auctions.1")],
        "/referral": [t("loadingPhrases.referral.0"), t("loadingPhrases.referral.1")],
        "/staking": [t("loadingPhrases.staking.0"), t("loadingPhrases.staking.1")],
        "/term-and-conditions": [t("loadingPhrases.terms.0"), t("loadingPhrases.terms.1")],
        "/airdrop": [t("loadingPhrases.airdrop.0"), t("loadingPhrases.airdrop.1")],
        "/legal-refund": [t("loadingPhrases.legalRefund.0"), t("loadingPhrases.legalRefund.1")],
        "/profile": [t("loadingPhrases.profile.0"), t("loadingPhrases.profile.1")],
        // ... add the rest of the phrases here
    };
    const phrases = loadingPhrases[currentPath] || loadingPhrases["/"];
    const randomPhrase = phrases[Math.floor(Math.random() * phrases.length)];
    if (isBot()) {
        return null;
    }
    if (!loading) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="text-center text-white p-4">
                <img
                    src="https://api.bidcoin.live/logo512.png"
                    alt="BidCoin Logo"
                    className="w-24 h-24 mx-auto mb-4 animate-spin"
                />
                <p className="text-2xl font-bold mb-2">{randomPhrase}</p>
                <p className="text-sm">{t("blockchainOverlay.holdTight")}</p>
            </div>
        </div>
    );
};
